export default {
  setContracts: (state, contracts) => {
    state.contracts = contracts;
  },

  setContract: (state, contract) => {
    state.contract = contract;
  },

  setContractsFilters: (state, contractsFilters) => {
    state.filters = contractsFilters;
  },

  setContractsPaginationOptions: (state, contractsPaginationOptions) => {
    state.paginationOptions = contractsPaginationOptions;
  }
};
